(() => {
  const formatRupees = (cents) => {
    const rupees = cents / 100;
    const digits = Number.isInteger(rupees) ? 0 : 2;
    return `₹${new Intl.NumberFormat('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(rupees)}`;
  };

  function init(section) {
    if (section.dataset.lhpReady === 'true') return;
    section.dataset.lhpReady = 'true';

    const slides = [...section.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    const thumbStrip = section.querySelector('.lhp__thumbs');
    const gallery = section.querySelector('.lhp__gallery');
    const stage = section.querySelector('[data-gallery-stage]');
    const counter = section.querySelector('[data-gallery-count]');
    const zoom = section.querySelector('[data-zoom-dialog]');
    let active = 0;
    let timer;
    let touchStartX = null;

    function showSlide(next) {
      if (!slides.length) return;
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== active; });
      thumbs.forEach((thumb, index) => {
        const selected = index === active;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-current', String(selected));
      });
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      const activeThumb = thumbs[active];
      if (thumbStrip && activeThumb) {
        const stripRect = thumbStrip.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        if (thumbRect.left < stripRect.left) thumbStrip.scrollLeft -= stripRect.left - thumbRect.left;
        else if (thumbRect.right > stripRect.right) thumbStrip.scrollLeft += thumbRect.right - stripRect.right;
      }
    }

    function stopAutoplay() { clearInterval(timer); }
    function startAutoplay() {
      stopAutoplay();
      if (slides.length < 2 || document.hidden || gallery.matches(':hover') || gallery.contains(document.activeElement) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(() => showSlide(active + 1), 7000);
    }

    section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => { showSlide(active - 1); startAutoplay(); });
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => { showSlide(active + 1); startAutoplay(); });
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => { showSlide(index); startAutoplay(); }));
    gallery?.addEventListener('mouseenter', stopAutoplay);
    gallery?.addEventListener('mouseleave', startAutoplay);
    gallery?.addEventListener('focusin', stopAutoplay);
    gallery?.addEventListener('focusout', () => setTimeout(startAutoplay, 0));
    gallery?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(active + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(active - 1); }
    });
    document.addEventListener('visibilitychange', startAutoplay);
    stage?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const difference = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(difference) > 45) showSlide(active + (difference < 0 ? 1 : -1));
      touchStartX = null;
      startAutoplay();
    }, { passive: true });
    slides.forEach((slide) => slide.addEventListener('click', () => {
      if (!zoom?.showModal) return;
      const image = zoom.querySelector('img');
      image.src = slide.dataset.imageUrl;
      image.alt = slide.dataset.imageAlt || '';
      stopAutoplay();
      zoom.showModal();
    }));
    zoom?.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoom.close());
    zoom?.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });
    zoom?.addEventListener('close', startAutoplay);
    startAutoplay();

    const quantity = section.querySelector('[data-quantity-input]');
    const packInputs = [...section.querySelectorAll('[data-pack-grid] input[type="radio"]')];
    const summary = section.querySelector('[data-pack-summary]');
    const stickySummary = section.querySelector('.lhp__sticky small');
    const unitPrice = Number(section.dataset.unitPrice || 0);

    function setQuantity(value) {
      if (!quantity) return;
      const count = Math.max(1, Math.min(99, Math.floor(Number(value) || 1)));
      quantity.value = String(count);
      packInputs.forEach((input) => {
        input.checked = Number(input.value) === count;
        input.closest('.lhp__pack')?.classList.toggle('is-selected', input.checked);
      });
      const bottles = `${count} ${count === 1 ? 'bottle' : 'bottles'}`;
      const discount = count >= 3 ? 35 : count === 2 ? 25 : 15;
      const total = formatRupees(unitPrice * count * (100 - discount) / 100);
      if (summary) summary.textContent = `Selected: ${bottles} · ${total} after ${discount}% off`;
      if (stickySummary) stickySummary.textContent = `${total} after ${discount}% off · ${bottles}`;
    }

    packInputs.forEach((input) => input.addEventListener('change', () => setQuantity(input.value)));
    quantity?.addEventListener('change', () => setQuantity(quantity.value));
    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQuantity(Number(quantity.value) - 1));
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQuantity(Number(quantity.value) + 1));
  }

  function initAll(root = document) { root.querySelectorAll('[data-lhp-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

